<!--  -->
<template>
  <div>
    <el-radio-group v-model="radio">
      <el-radio :label="1">文字</el-radio>
      <el-radio :label="2">图片</el-radio>
      <el-radio :label="3">小程序卡片</el-radio>
      <el-radio :label="4">指定小程序</el-radio>
    </el-radio-group>
    <div v-if="radio == 4" class="dawer" style="margin-top:20px">
      <div class="wechartext">小程序Appid：</div>
      <el-input v-model.trim="shuruappid" placeholder="请输入小程序Appid" style="width:300px" @blur="removeSpaces" />
    </div>
    <div v-if="radio!=4" style="margin-top:20px" class="dawer">
      <div class="wechartext">小程序类型：</div>
      <el-select v-model="appid" placeholder="请选择类型" @change="chawer">
        <el-option
          v-for="items in programtype"
          :key="items.mini_program_type"
          :label="items.type_name"
          :value="items.mini_program_type"
        />
      </el-select>
    </div>
    <div class="dawer">
      <div class="wechartext">链接：</div>
      <el-input v-model.trim="link" placeholder="请输入链接" style="width:300px" @blur="removeSpaceslink" />
    </div>
    <div v-if="radio == 1" class="dawer">
      <div class="wechartext">标题：</div>
      <el-input v-model="title" style="width:300px" placeholder="请输入标题" />
    </div>

    <div v-if="radio == 2" class="dawer">
      <div class="wechartext">上传图片：</div>
      <div>
        <img v-if="imgid!=null" :src="imgsrc" alt="" style="width:100px;height:100px">
        <div>
          <!-- <el-button type="primary" size="mini" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change.stop="uploadPictures"></el-button> -->
          <el-button type="primary" size="mini" @click.stop="updatapic">素材库选择/上传</el-button>
        </div>
      </div>
    </div>
    <div v-if="radio == 3 || radio == 4">
      <div style="display:flex;align-items: center;">
        <div class="wechartext">上传图片：</div>
        <div>
          <img v-if="kapianid!=null" :src="kapianidsrc" alt="" style="width:100px;height:100px">
          <div>
            <!-- <el-button type="primary" size="mini" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPicturesone"></el-button> -->
            <el-button type="primary" size="mini" @click.stop="updatapicr">素材库选择/上传</el-button>
          </div>
        </div>
      </div>
      <div class="updatatips">*请上传图片必须为1080*864像素*</div>
      <div class="dawer">
        <div class="wechartext">卡片样式：</div>
        <div class="cardstyeew">
          <div class="namew">{{ name }}</div>
          <div class="namewr">{{ cardinput }}</div>
          <div class="pic_box">
            <img v-if="kapianid!=null" :src="kapianidsrc" alt="" style="width:240px;height:180px">
          </div>
          <div class="bottom_box">
            <img src="https://ziyuan.jingxuansz.com/user/unfcss--下载.png" alt="" style="width:14px;height:14px">
            <div class="wechatrwname">小程序</div>
          </div>
        </div>
      </div>
      <div class="dawer">
        <div class="wechartext">卡片标题：</div>
        <el-input v-model="cardinput" style="width:300px;" placeholder="请输入卡片标题" maxlength="35" />
      </div>
      <!-- <div class="dawer">
        <div class="wechartext">卡片链接：</div>
        <el-input v-model="cardlink" style="width:300px;" placeholder="请输入卡片链接" />
      </div> -->
    </div>
    <el-button style="margin-top:20px" size="mini" type="primary" @click="onclwe">确定</el-button>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
    >
      <chooseimg ref="mychild" @clickicongon="clickicongon" />
    </el-dialog>
  </div>
</template>

<script>
import { mptypeslist, newMaterial } from '@/api/sourceMaterial.js'
import chooseimg from './chooseimg.vue'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    chooseimg
  },
  mixins: [getNowDate],
  data() {
    return {
      name: '',
      radio: 1,
      programtype: [],
      appid: null,
      link: '',
      title: '',
      dialogVisible: false,
      imgsrc: '',
      imgid: null,
      kapianid: null,
      kapianidsrc: '',
      cardinput: '',
      cardlink: '',
      obj: {},
      shuruappid: ''
    }
  },
  created() {
    this.getmptypeslist()
    this.getQiniuToken()
  },
  mounted() {

  },
  methods: {
    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist({
        mass: 1
      })
      this.programtype = data.data.types
      console.log('data', data.data.types)
    },
    chawer(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      const index = this.programtype.findIndex(v => v.mini_program_type == val)
      this.link = this.programtype[index].index_path
      this.name = this.programtype[index].type_name
    },
    // 根据网络地址获取图片的宽高
    getBase64(img) {
      const image = new Image()
      image.crossOrigin = ''
      image.src = img
      return new Promise((resolve, reject) => {
        image.onload = function() {
          const { width, height } = image
          resolve({ width, height })
        }
      })
    },

    async uploadPictures(e) {
      console.log('e', e)
      const fileIfon = e.target.files[0]
      const img = new Image()
      const temporary = window.URL.createObjectURL(fileIfon)
      console.log('temporary', temporary)
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          }).then(res => {
            console.log('res', res)
            this.$message({
              type: 'success',
              message: '上传成功!'
            })
            this.imgsrc = res.data.path
            this.imgid = res.data.sourceMaterialId
            // editor.dangerouslyInsertHtml(`<img src="${res.data.path}">`)
          })
        }

      })
    },
    async uploadPicturesone(e) {
      const fileIfon = e.target.files[0]
      const img = new Image()
      const temporary = window.URL.createObjectURL(fileIfon)
      console.log('temporary', temporary)
      this.getBase64(temporary).then((res) => {
        console.log('res', res)
        // eslint-disable-next-line eqeqeq
        if (res.width != 1080 && res.height != 864) {
          this.$message.error('请上传图片必须为1080*864像素')
          return
        }
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
          fname: fileIfon.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key,
              business_type: 16
            }).then(res => {
              console.log('res', res)
              this.$message({
                type: 'success',
                message: '上传成功!'
              })
              this.kapianidsrc = res.data.path
              this.kapianid = res.data.sourceMaterialId
            // editor.dangerouslyInsertHtml(`<img src="${res.data.path}">`)
            })
          }

        })
      })
    },
    updatapic() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.send(1, 0)
      }, 100)
    },
    updatapicr() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.send(1, 16)
      }, 100)
    },
    clickicongon(item) {
      console.log('item', item)
      this.dialogVisible = false
      // eslint-disable-next-line eqeqeq
      if (this.radio == 2) {
        this.imgsrc = item.path
        this.imgid = item.id
      }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 3) {
        this.kapianidsrc = item.path
        this.kapianid = item.id
      }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 4) {
        this.kapianidsrc = item.path
        this.kapianid = item.id
      }
    },
    onclwe() {
      // 文字
      this.obj = {}
      // eslint-disable-next-line eqeqeq
      if (this.appid === null && this.radio != 4) {
        this.$message.error('请选择小程序类型')
        return
      }
      if (this.link === '') {
        this.$message.error('请输入链接')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 1) {
        if (this.title === '') {
          this.$message.error('请输入标题')
          return
        }
        console.log('文字')
        this.obj.appid = this.appid
        this.obj.link = this.link
        this.obj.title = this.title
        this.$emit('callback', this.obj, this.radio)
        // eslint-disable-next-line eqeqeq
      } else if (this.radio == 2) {
        if (this.imgid === null) {
          this.$message.error('请选择图片')
          return
        }
        this.obj.appid = this.appid
        this.obj.link = this.link
        this.obj.title = this.title
        this.obj.imgsrc = this.imgsrc
        this.obj.imgid = this.imgid
        console.log('图片')
        this.$emit('callback', this.obj, this.radio)
      // eslint-disable-next-line eqeqeq
      } else if (this.radio == 3) {
        console.log('卡片')
        if (this.kapianid === null) {
          this.$message.error('请选择图片')
          return
        }
        if (this.cardinput === '') {
          this.$message.error('请输入卡片标题')
          return
        }
        this.obj.appid = this.appid
        this.obj.link = this.link
        this.obj.title = this.title
        this.obj.imgsrc = this.kapianidsrc
        this.obj.imgid = this.kapianid
        this.obj.cardinput = this.cardinput
        // this.obj.cardlink = this.cardlink
        this.$emit('callback', this.obj, this.radio)
      } else {
        console.log('指定小程序')
        if (this.shuruappid === '') {
          this.$message.error('请输入小程序appid')
          return
        }
        if (this.kapianid === null) {
          this.$message.error('请选择图片')
          return
        }
        if (this.cardinput === '') {
          this.$message.error('请输入卡片标题')
          return
        }
        this.obj.appid = this.shuruappid
        this.obj.link = this.link
        this.obj.title = this.title
        this.obj.imgsrc = this.kapianidsrc
        this.obj.imgid = this.kapianid
        this.obj.cardinput = this.cardinput
        // this.obj.cardlink = this.cardlink
        this.$emit('callback', this.obj, this.radio)
      }
    },
    removeSpaces() {
      this.shuruappid = this.shuruappid.replace(/\s+/g, '')
    },
    removeSpaceslink() {
      this.link = this.link.replace(/\s+/g, '')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.cardstyeew{
  background-color:#f6f7f8;
  border: 1px solid #e3e4e5;
  border-radius: 2px;
  width: 272px;
  margin-top: 10px;
  /* height: 220px; */
}
.namew{
  padding-left: 20px;
  padding-top: 20px;
}
.namewr{
   padding-left: 20px;
}
.pic_box{
  margin-top: 10px;
  border: 1px dashed #e3e4e5;
  background-color:#fff;
  width: 240px;
  height: 180px;
  margin-left: 15px;
}
.bottom_box{
  display: flex;
  align-items: center;
  border-top: 1px solid #e3e4e5;
  margin-top: 10px;
  padding: 5px 0px 5px 20px;
}
.wechatrwname{
  color: #7e8081;
  font-size: 14px;
  margin-left: 2px;
}
.dawer{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.wechartext{
  width: 100px;
  text-align: right;
}
.updatatips{
  color: red;
  margin-left: 20px;
  margin-top: 10px;
}
</style>
